import React from "react";
import "../styles/HomePageV2.css";
import { HeroSectionV2 } from "../homepageV2/HeroSectionV2";
import { WelcomeSectionV2 } from "../homepageV2/WelcomeSectionV2";
import { StoriesSectionV2 } from "../homepageV2/StoriesSectionV2";
import { EventsSectionV2 } from "../homepageV2/EventsSectionV2";
import { ProgramsSectionV2 } from "../homepageV2/ProgramsSectionV2";
import { TestimonialsSectionV2 } from "../homepageV2/TestimonialsSectionV2";
import { MListSectionV2 } from "../homepageV2/MListSectionV2";
import { CollectiveSectionV2 } from "../homepageV2/CollectiveSectionV2";
import { AboutSectionV2 } from "../homepageV2/AboutSectionV2";
import { FooterCtaSectionV2 } from "../homepageV2/FooterCtaSectionV2";

/**
 * HomePage V2 — mirrors HomePage.jsx structure with isolated mh2v2 styles.
 * Preview: /twentytwentysix/home-v2
 */
export default function HomePageV2() {
  return (
    <div className="mh2v2-page">
      <HeroSectionV2 />
      <WelcomeSectionV2 />
      <StoriesSectionV2 />
      <EventsSectionV2 />
      <ProgramsSectionV2 />
      <TestimonialsSectionV2 />
      <MListSectionV2 />
      <CollectiveSectionV2 />
      <AboutSectionV2 />
      <FooterCtaSectionV2 />
    </div>
  );
}
